* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 874px;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .SVA-patch {
    display: flex;
    margin-bottom: calc(var(--spacer) * 2.5);
    gap: calc(var(--spacer) * 10 + 3px);

    justify-content: flex-start;
    align-items: center;

    #search-SVA-input {
      flex: 0;
      margin-right: var(--spacer);
    }

    #custom-SVA-input {
      flex: 0;
      margin-right: var(--spacer);
    }

    #search-SVA-label {
      font-size: var(--body-size-medium);
    }

    #search-SVA-boxes {
      display: flex;
      justify-content: flex-start;
      //align-items: center;
      gap: calc(var(--spacer) * 2);
    }
  }

  #use-SSL {
    padding-top: 18px;
  }
}

.box-info::part(container) {
  padding: unset;
  width: 870px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.form-field-input {
  width: var(--form-field-label-width);
  margin-top: calc(var(--spacer) * 1.5);
}

#vendor-selector {
  display: inline;
}

#product-selector {
  display: inline;
}

#add-button {
  display: inline;
}

#no-results-subtitle {
  margin: 0;
  font-size: var(--body-size-medium);
  color: var(--body-text-arrows-400);
}

.hidden {
  display: none;
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}
